import React from 'react';
import Navlogo from './images/Logo2.jpg'; // Ensure this path is correct

const Footer = () => {
  return (
    <footer className="classic-footer">
      <div className="footer-container">
        
        {/* Top Section: 3 Columns */}
        <div className="footer-row">
          
          {/* Column 1: Brand */}
          <div className="footer-col brand-col">
            <img src={Navlogo} alt="Green Knowledge Logo" className="footer-logo" />
            <p className="brand-description">
              Pioneering sustainable agriculture through advanced machinery and modern solutions.
            </p>
          </div>

          {/* Column 2: Navigation */}
          <div className="footer-col links-col">
            <h5 className="footer-heading">Explore</h5>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/innovation">innovation</a></li>
              <li><a href="/products">products</a></li>
              <li><a href="/jobs">jobs</a></li>
              <li><a href="/aboutus">About us</a></li>
              <li><a href="/contact">Contact US</a></li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="footer-col contact-col">
            <h5 className="footer-heading">Get in Touch</h5>
            <address className="footer-address">
              <p><span>India:</span> +91-8675221100</p>
              <p><span>Singapore:</span> +65-88737903</p>
              <p>
                <span>Email:</span>
                <br/>
                 <a href="mailto:k.v.g.krish100@gmail.com">k.v.g.krish100@gmail.com</a>
                 <br/>
                 <a href="mailto:gokul@greenowledge.onmicrosoft.com">gokul@greenowledge.onmicrosoft.com</a>
              </p>
            </address>
          </div>
        </div>

        {/* Divider Line */}
        <hr className="footer-divider" />

        {/* Bottom Section: Copyright */}
        <div className="footer-bottom">
          <p className="copyright-text">
            &copy; {new Date().getFullYear()} Green Knowledge. All rights reserved.
          </p>
          <p className="designer-credit">Designed by Green Knowledge Team</p>
        </div>
      </div>

      <style>{`
        /* --- Classic Footer Styles --- */
        .classic-footer {
          background-color: #0f172a; /* Deep Navy / Dark Slate Blue */
          color: #f8fafc; /* Off-white for softer reading */
          font-family: 'Georgia', 'Times New Roman', serif; /* Classic Serif font feel */
          padding: 4rem 2rem 2rem;
        }

        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .footer-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 3rem;
        }

        .footer-col {
          flex: 1;
          min-width: 250px;
        }

        /* Brand Column Specifics */
        .brand-col {
          flex: 1.5; /* Takes up slightly more space */
        }
        .footer-logo {
          max-width: 150px;
          margin-bottom: 1.5rem;
          // filter: brightness(0) invert(1); /* Forces logo to be white if it isn't already */
        }
        .brand-description {
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; /* Sans-serif for body text */
          font-size: 0.95rem;
          line-height: 1.6;
          color: #cbd5e1; /* Light gray */
        }

        /* Headings */
        .footer-heading {
          font-size: 1.1rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 1.5rem;
          border-bottom: 1px solid #334155;
          padding-bottom: 10px;
          display: inline-block;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        }

        /* Links */
        .footer-links {
          list-style: none;
          padding: 0;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        }
        .footer-links li {
          margin-bottom: 0.8rem;
        }
        .footer-links a {
          color: #cbd5e1;
          text-decoration: none;
          transition: color 0.2s ease, padding-left 0.2s ease;
        }
        .footer-links a:hover {
          color: #ffffff;
          padding-left: 5px; /* Subtle movement effect */
        }

        /* Contact Address */
        .footer-address {
          font-style: normal;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-size: 0.95rem;
          color: #cbd5e1;
        }
        .footer-address p {
          margin-bottom: 0.8rem;
        }
        .footer-address span {
          font-weight: bold;
          color: #ffffff;
          display: inline-block;
          width: 80px; /* Aligns the data nicely */
        }
        .footer-address a {
          color: #cbd5e1;
          text-decoration: none;
        }
        .footer-address a:hover {
          text-decoration: underline;
          color: #fff;
        }

        /* Divider & Bottom */
        .footer-divider {
          border: 0;
          border-top: 1px solid #334155; /* Subtle divider */
          margin: 3rem 0 2rem;
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-size: 0.85rem;
          color: #94a3b8;
        }
        
        @media (max-width: 768px) {
          .footer-row {
            flex-direction: column;
            gap: 2rem;
          }
          .footer-bottom {
            flex-direction: column;
            text-align: center;
            gap: 1rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;